export default "/toucan-icon.503489f6747359ad6300aa7cc26e25a6.png";